export default class FontDefinition
{

  constructor(fontName) {

    this.fontName = fontName;
    this.fontSize = 10;
    this.fontWeight = 'normal';

    this.zoom = 1;

  }

  name(name) {
    this.fontName = name;
    return this;
  }

  size(size) {
    this.fontSize = size;
    return this;
  }

  getSize(original){
    if (original === true) {
      return this.fontSize / this.zoom;
    }
    return this.fontSize;
  }

  weight(weight) {
    this.fontWeight = weight;
    return this;
  }

  scale(zoom) {
    if (this.zoom !== zoom){

      this.fontSize = zoom * (this.fontSize / this.zoom);
      this.zoom = zoom;

    }
    return this;
  }

  toString() {
    return this.fontWeight + ' ' + Math.floor(this.fontSize) + 'px ' + this.fontName;
  }

}
